<template>
  <div>
    <CRow>
      <CCol lg="12">
        <div class="text-center p-5 row" v-if="isLoading">
          <semipolar-spinner :animation-duration="2000" :size="80" color="#63c2de" class="offset-6"></semipolar-spinner>
        </div>
        <Table-Stereotypes
          :table-data="items"
          :fields="fields"
          caption=" <h4><i class='fas fa-street-view mr-2'></i>Estereotipos</h4>"
          v-else
        ></Table-Stereotypes>
      </CCol>
    </CRow>
  </div>
</template>

<script>
import { shuffleArray } from "@/shared/utils";
import TableStereotypes from "./TableStereotypes";
import store from "../../store";
import { SemipolarSpinner } from "epic-spinners";

import {
  mdbContainer,
  mdbModal,
  mdbModalBody,
  mdbModalHeader,
  mdbModalFooter,
  mdbRow,
  mdbBtn,
  mdbIcon,
  mdbTextarea,
  mdbInput
} from "mdbvue";

export default {
  name: "facebookPages",
  components: {
    TableStereotypes,
    SemipolarSpinner,
    mdbContainer,
    mdbModal,
    mdbModalBody,
    mdbModalHeader,
    mdbModalFooter,
    mdbRow,
    mdbBtn,
    mdbIcon,
    mdbTextarea,
    mdbInput
  },
  data: () => {
    return {
      items: [],
      itemsArray: [],
      fields: [
        { key: "name", label: "Nombre", sortable: true },
        { key: "gender", label: "Género", sortable: true },
        { key: "age_min", label: "Edad mínima", sortable: true },
        { key: "age_max", label: "Edad maxima", sortable: true },
        { key: "acciones", label: "Acciones" }
      ],
      isLoading: false
    };
  },
  mounted() {
    this.getStereotypes();
  },
  methods: {
    getStereotypes() {
      var stereotypes = store.getters.getStereotypes;
      if (stereotypes.length == 0) {
        this.isLoading = true;
        store.dispatch("getStereotypes").then(() => {
          stereotypes = store.getters.getStereotypes;
          shuffleArray([stereotypes]);
          this.isLoading = false;
          this.items = stereotypes;
          this.itemsArray = stereotypes;
        });
      } else {
        shuffleArray([stereotypes]);
        this.items = stereotypes;
        this.itemsArray = stereotypes;
      }
    }
  }
};
</script>
